import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-exploring-evaluation-criteria',
    templateUrl: './exploring-evaluation-criteria.component.html',
    styleUrls: ['./exploring-evaluation-criteria.component.scss'],
    standalone: false
})
export class ExploringEvaluationCriteriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
